import gql from "graphql-tag";

export default gql`mutation CreateVatTest($test:Boolean!, $vrn:Int!, $clientHeaders:JSON!) {
    createVatTest(test:$test, vrn:$vrn, clientHeaders:$clientHeaders) 
  }`